import { schema } from 'normalizr';

export const labelSchema = new schema.Entity('label');
